import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useMemo } from 'react';
import PT from 'prop-types';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import merge from 'lodash.merge';
import { record } from '../../utils/types/prop-types';
import { applyPolymorphicFunctionProp, objectKeys, objectValues } from '../../utils/functions';
import { Breakpoint, BreakpointClass } from '../../utils/types/css';
import { Color } from '../../utils/types/palette';
import { FontVariant } from '../../utils/types/typography';
import { BorderRadiusSize } from '../../utils/types/shape';
import { defaultTheme } from '../entity';
import { Typography, CommonStyles } from '../roots';
import { defaultPalette } from '../roots/palette';
import createBreakpoints from '../entity/create-breakpoints';

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme;
  var _theme$palette = theme.palette,
      paletteOverride = _theme$palette === void 0 ? {} : _theme$palette,
      _theme$breakpoints = theme.breakpoints,
      breakpointsOverride = _theme$breakpoints === void 0 ? {} : _theme$breakpoints,
      _theme$typography = theme.typography,
      typographyOverride = _theme$typography === void 0 ? {} : _theme$typography,
      _theme$shape = theme.shape,
      shapeOverride = _theme$shape === void 0 ? {} : _theme$shape;
  var finalTheme = useMemo(function () {
    var palette = _objectSpread(_objectSpread({}, defaultPalette), paletteOverride);

    var breakpoints = createBreakpoints(breakpointsOverride);
    return {
      palette: palette,
      breakpoints: breakpoints,
      typography: _objectSpread({}, merge(_objectSpread({}, defaultTheme.typography), _objectSpread({}, typographyOverride))),
      shape: _objectSpread({}, merge(_objectSpread({}, defaultTheme.shape), _objectSpread({}, shapeOverride)))
    };
    return {};
  }, [JSON.stringify(theme)]);
  return /*#__PURE__*/React.createElement(SCThemeProvider, {
    theme: finalTheme
  }, /*#__PURE__*/React.createElement(React.Fragment, null, applyPolymorphicFunctionProp(children, finalTheme), /*#__PURE__*/React.createElement(CommonStyles, null), /*#__PURE__*/React.createElement(Typography, null)));
};

var _defaultTheme$typogra = defaultTheme.typography,
    baseLineHeight = _defaultTheme$typogra.baseLineHeight,
    font = _defaultTheme$typogra.font,
    typography = _objectWithoutProperties(_defaultTheme$typogra, ["baseLineHeight", "font"]);

ThemeProvider.propTypes = {
  children: PT.oneOfType([PT.node, PT.func, PT.arrayOf(PT.node)]).isRequired,
  theme: PT.exact({
    breakpoints: PT.exact({
      keys: PT.arrayOf(PT.string),
      values: PT.exact(record(objectValues(Breakpoint), PT.number)),
      classes: PT.exact(record(objectKeys(BreakpointClass), PT.string)),
      getBreakpointClass: PT.func,
      up: PT.func,
      down: PT.func,
      between: PT.func,
      only: PT.func
    }),
    palette: PT.exact(record(objectValues(Color), PT.string)),
    shape: PT.exact({
      borderRadius: PT.exact(record(objectValues(BorderRadiusSize), PT.string))
    }),
    typography: PT.exact(_objectSpread({
      baseLineHeight: PT.oneOfType([PT.string, PT.number]),
      font: PT.exact(record(objectValues(FontVariant), PT.object))
    }, record(objectKeys(typography), PT.string)))
  })
};
export default ThemeProvider;